import {

    List,
    EditButton,
    Datagrid,
    TextField, ReferenceManyCount, Link, useRecordContext,
    Filter,
    TextInput,
    useGetList,
    AutocompleteInput,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { DeleteWithDialogAction } from "../../common/DeleteWithDialogAction";
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import banner_categories from '.';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const FaqsLinkComponent = () => {
    const record = useRecordContext();
    return <Link
        to={`/faqs?filter=${encodeURIComponent(JSON.stringify({ categoryId: record.id }))}`}>
        FAQS
    </Link>
}

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);
const FaqCategoriesList = () => {
    const { isDeletable, isWritable, isUpdatable } = useIsPermission("FAQS");

    return (
        <div>
            <List
                filters={<ListFilter />}
                actions={<PermissionBasedActions isWritable={isWritable} />}
                sort={{ field: 'display_order', order: 'ASC' }}
                queryOptions={{
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                }}
            >
                <Datagrid>
                    <TextField source="name" />
                    <FormattedDateTimeField source="created_at" />
                    <FaqsLinkComponent />
                    {isUpdatable &&
                        <EditButton />
                    }
                    {isDeletable &&
                        <ConfirmDeleteButton />
                    }
                </Datagrid>
            </List>
        </div>
    );
};
export default FaqCategoriesList;
